/**
 * Приводит ссылку на видео к embed-виду для плеера.
 *
 * Принимает и «человеческую» ссылку (`youtube.com/watch?v=ID`, `youtu.be/ID`),
 * и уже готовую embed-форму — бэкенду не нужно знать про формат каждого
 * хостинга. Возвращает `null`, если хост не разрешён: тогда контент
 * отрисуется как обычная картинка/ссылка, а не как плеер.
 *
 * Только https: http-фрейм на https-странице всё равно заблокирует браузер.
 */
export function toEmbedUrl(src: string): string | null {
	let url: URL;
	try {
		url = new URL(src);
	} catch {
		return null;
	}

	if (url.protocol !== 'https:') return null;

	const host = url.hostname.replace(/^www\./, '');
	const path = url.pathname.replace(/\/+$/, '');

	if (host === 'kinescope.io') {
		// /embed/ID — как есть; /ID — дописываем /embed.
		const id = path.replace(/^\/(embed\/)?/, '');
		return id ? `https://kinescope.io/embed/${id}` : null;
	}

	if (host === 'youtu.be') {
		const id = path.slice(1);
		return id ? `https://www.youtube.com/embed/${id}` : null;
	}

	if (host === 'youtube.com') {
		if (path.startsWith('/embed/')) return url.toString();
		const id = url.searchParams.get('v');
		return id ? `https://www.youtube.com/embed/${id}` : null;
	}

	return null;
}
